module.exports = __webpack_public_path__ + "img/bonus_symbol_0.a2be6954.png";